<hr class="eiq-break-line" [ngClass]="color" />
